const state = {
    jumpParams:{},//页面跳转参数
};

const mutations = {
    setJumpParams: (state, n) => {
        state.jumpParams = n;
    },
};

export default {
    namespaced: true,
    state,
    mutations,
};